/* eslint-disable @next/next/no-img-element */
import React from 'react';

import PropTypes from 'prop-types';

import {
    MarkdownContent,
    Typography,
    WDSButton,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

import shuttleGuideConfig from '../../locales.config';
import events from './events/ShuttleEvents';

import styles from './Shuttle.scss';

const { namespace } = shuttleGuideConfig;

const Shuttle = (props) => {
    const {
        description,
        logo,
        name,
        url,
        website,
    } = props;

    const onClick = () => {
        events.ctaSelected({ name, url });

        window.open(website, '_blank');
    };

    return (
        <button
            className={styles.container}
            onClick={onClick}
        >
            <ul className={styles.head}>
                <li>
                    <img
                        alt={name}
                        className={styles.logo}
                        src={logo}
                    />
                </li>
                <li>
                    <Typography>{name}</Typography>
                </li>
            </ul>
            <Typography component={MarkdownContent} >
                {description}
            </Typography>
        </button>
    );
};

Shuttle.propTypes = {
    description: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    website: PropTypes.string.isRequired,
};

export { Shuttle };

export default localize(Shuttle, ['t'], namespace);
